import React from 'react';
import { Routes, Route } from 'react-router-dom';

/*사용자정보*/
import { useContext, useEffect } from 'react';
import { AuthContext } from './context/AuthContext';
/*사용자정보*/

import Layout from './ui/Layout';
import Portal from './pages/Portal';
import Login from './pages/auth/Login';
import AuthCallback from './pages/auth/AuthCallback';
import RegisterUser from './pages/auth/RegisterUser';

import BoardList from './pages/board/PostList';
import WritePost from './pages/board/WritePost';
import EditPost from './pages/board/EditPost';
import ViewPost from './pages/board/ViewPost';
import WriteResponse from './pages/board/WriteResponse';
import EditResponse from './pages/board/EditResponse';

import UserList from './pages/user/UserList';
import UserCreate from './pages/user/UserCreate';
import UserEdit from './pages/user/UserEdit';
import UserView from './pages/user/UserView';

import DeptList from './pages/dept/DeptList';
import DeptForm from './pages/dept/DeptForm';
import DeptView from './pages/dept/DeptView';
import DeptEdit from './pages/dept/DeptEdit';

import OrgChart from './pages/org/OrgChart';

import AuthGuard from './ui/AuthGuard';

import BoardCodeListPage from './pages/code/BoardCodeListPage';
import BoardCodeDetailPage from './pages/code/BoardCodeDetailPage';
import BoardCodeEditPage from './pages/code/BoardCodeEditPage';
import BoardCodeCreatePage from './pages/code/BoardCodeCreatePage';

import AprvFormsList from './pages/aprvForm/AprvFormsList';
import AprvFormsForm from './pages/aprvForm/AprvFormsForm';
import AprvFormsEdit from './pages/aprvForm/AprvFormsEdit';
import AprvFormsView from './pages/aprvForm/AprvFormsView';

import AprvDocForm from './pages/aprvdoc/AprvDocForm';
import AprvDocList from './pages/aprvdoc/AprvDocList';
import AprvDocView from './pages/aprvdoc/AprvDocView';
import AprvDocEdit from './pages/aprvdoc/AprvDocEdit';
import AprvDocListByAdmin from './pages/aprvdoc/AprvDocListByAdmin';

import ResourceMng from './pages/resource/ResourceMng';
import ReservationCreate from './pages/resource/ReservationCreate';
import ReservationView from './pages/resource/ReservationView';
import ReservationCalendar from './pages/resource/ReservationCalendar';
import ReservationList from './pages/resource/ReservationList';

import ScheduleList from './pages/schedule/ScheduleList';
import ScheduleForm from './pages/schedule/ScheduleForm';
import ScheduleCalendar from './pages/schedule/ScheduleCalendar';
//import ScheduleEdit from './pages/schedule/ScheduleEdit';

//import ManagerList from './pages/manager/ManagerList';
import ManagerCreate from './pages/manager/ManagerCreate';
import ManagerEdit from './pages/manager/ManagerEdit';
import ManagerDetail from './pages/manager/ManagerDetail';
import LeftMenuList from './pages/manager/leftMenu/LeftMenuList';
import PortletList from './pages/manager/portlet/PortletList';

import TodoList from './pages/todo/TodoList';
import AiGemin from './pages/tdxai/AiGemin';

import InstructionList from './pages/pms/InstructionList';
import InstructionForm from './pages/pms/InstructionForm';
import InstructionView from './pages/pms/InstructionView';
import ProjectList from './pages/pms/ProjectList';
import ProjectForm from './pages/pms/ProjectForm';
import ProjectView from './pages/pms/ProjectView';
import MyWorkspace from './pages/pms/MyWorkspace';
import ProjectWorkspace from './pages/pms/Workspace/ProjectWorkspace';

import WorkOrderMatrix from './pages/workOrder/WorkOrderMatrix';
import WorkOrderListPage from './pages/workOrder/WorkOrderListPage';
import WorkOrderTimeline from './pages/workOrder/WorkOrderTimeline';

import RiskList from './pages/risk/RiskList';
import RiskForm from './pages/risk/RiskForm';
import RiskEdit from './pages/risk/RiskEdit';
import RiskView from './pages/risk/RiskView';
import RiskCateList from './pages/riskcate/RiskCateList';
import SafetyProjectList from './pages/safety/projects/SafetyProjectList';
import SafetyProjectDetail from './pages/safety/projects/SafetyProjectDetail';
import SafetyActionList from './pages/safety/projects/SafetyActionList';
import SafetyResultList from './pages/safety/projects/SafetyResultList';
import SafetyMaster from './pages/safety/master/SafetyMaster';

function TdxMain() {
  /*사용자정보*/
  const { user } = useContext(AuthContext);
  // 브라우저 탭 제목 동적 변경
  useEffect(() => {
    if (user) {
      document.title = `TDX 3.0 (${user.name}/${user.userid})`;
    } else {
      document.title = 'TDX 3.0';
    }
  }, [user]);
  /*사용자정보*/

  return (
    <Routes>
      {/* ✅ 로그인은 독립 페이지 */}
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* ✅ "/" 는 Sidebar가 첫 메뉴로 리다이렉트 처리 — 컨텐츠 없이 Layout만 렌더링 */}
      <Route path="/" element={<AuthGuard><Layout><Portal /></Layout></AuthGuard>} />
      <Route path="/portal" element={<AuthGuard><Layout><Portal /></Layout></AuthGuard>} />

      {/* ✅ 나머지 인증 경로들 */}
      <Route path="/register" element={<AuthGuard><Layout><RegisterUser /></Layout></AuthGuard>} />

      {/* ✅ 게시판 */}
      <Route path="/board" element={<AuthGuard><Layout><BoardList /></Layout></AuthGuard>} />
      <Route path="/write" element={<AuthGuard><Layout><WritePost /></Layout></AuthGuard>} />
      <Route path="/edit/:id" element={<AuthGuard><Layout><EditPost /></Layout></AuthGuard>} />
      <Route path="/post/:id" element={<AuthGuard><Layout><ViewPost /></Layout></AuthGuard>} />

      {/* ✅ 게시판 응답처리 */}
      <Route path="/response/write/:parentId" element={<AuthGuard><Layout><WriteResponse /></Layout></AuthGuard>} />
      <Route path="/response/edit/:id" element={<AuthGuard><Layout><EditResponse /></Layout></AuthGuard>} />

      {/* ✅ 게시판 코드 관리 */}
      <Route path="/board-codes" element={<AuthGuard><Layout><BoardCodeListPage /></Layout></AuthGuard>} />
      <Route path="/board-codes/new" element={<AuthGuard><Layout><BoardCodeCreatePage /></Layout></AuthGuard>} />
      <Route path="/board-codes/:id" element={<AuthGuard><Layout><BoardCodeDetailPage /></Layout></AuthGuard>} />
      <Route path="/board-codes/:id/edit" element={<AuthGuard><Layout><BoardCodeEditPage /></Layout></AuthGuard>} />

      {/* ✅ 사용자 관리 */}
      <Route path="/users" element={<AuthGuard><Layout><UserList /></Layout></AuthGuard>} />
      <Route path="/users/:id" element={<AuthGuard><Layout><UserView /></Layout></AuthGuard>} />
      <Route path="/users/create" element={<AuthGuard><Layout><UserCreate /></Layout></AuthGuard>} />
      <Route path="/users/edit/:id" element={<AuthGuard><Layout><UserEdit /></Layout></AuthGuard>} />

      {/* ✅ 부서 관리 */}
      <Route path="/dept" element={<AuthGuard><Layout><DeptList /></Layout></AuthGuard>} />
      <Route path="/dept/new" element={<AuthGuard><Layout><DeptForm /></Layout></AuthGuard>} />
      <Route path="/dept/view/:code" element={<AuthGuard><Layout><DeptView /></Layout></AuthGuard>} />
      <Route path="/dept/edit/:code" element={<AuthGuard><Layout><DeptEdit /></Layout></AuthGuard>} />

      {/* ✅ 조직도 */}
      <Route path="/orgchart" element={<AuthGuard><Layout><OrgChart /></Layout></AuthGuard>} />

      {/* ✅ 결재양식 관리 */}
      <Route path="/aprv/forms" element={<AuthGuard><Layout><AprvFormsList /></Layout></AuthGuard>} />
      <Route path="/aprv/forms/new" element={<AuthGuard><Layout><AprvFormsForm /></Layout></AuthGuard>} />
      <Route path="/aprv/forms/:formCode" element={<AuthGuard><Layout><AprvFormsView /></Layout></AuthGuard>} />
      <Route path="/aprv/forms/:formCode/edit" element={<AuthGuard><Layout><AprvFormsEdit /></Layout></AuthGuard>} />

      {/* ✅ 결재문서 */}
      <Route path="/aprvdoc/form" element={<AuthGuard><Layout><AprvDocForm /></Layout></AuthGuard>} />
      <Route path="/aprvdoc" element={<AuthGuard><Layout><AprvDocList /></Layout></AuthGuard>} />
      <Route path="/aprvdoc/view/:aprvId" element={<AuthGuard><Layout><AprvDocView /></Layout></AuthGuard>} />
      <Route path="/aprvdoc/edit/:aprvId" element={<AuthGuard><Layout><AprvDocEdit /></Layout></AuthGuard>} />
      <Route path="/aprvdoc/admin" element={<AuthGuard><Layout><AprvDocListByAdmin /></Layout></AuthGuard>} />

      {/* ✅ 자원관리-예약 */}
      <Route path="/resources" element={<AuthGuard><Layout><ResourceMng /></Layout></AuthGuard>} />
      <Route path="/reservations/calendar" element={<AuthGuard><Layout><ReservationCalendar /></Layout></AuthGuard>} />
      <Route path="/reservations/list" element={<AuthGuard><Layout><ReservationList /></Layout></AuthGuard>} />
      <Route path="/reservations/new" element={<AuthGuard><Layout><ReservationCreate actionType="create" /></Layout></AuthGuard>} />
      <Route path="/reservations/:id" element={<AuthGuard><Layout><ReservationView /></Layout></AuthGuard>} />

      {/* ✅ 일정관리 */}
      <Route path="/schedule/new" element={<AuthGuard><Layout><ScheduleForm /></Layout></AuthGuard>} />
      <Route path="/schedule/calendar" element={<AuthGuard><Layout><ScheduleCalendar /></Layout></AuthGuard>} />
      <Route path="/schedule/list" element={<AuthGuard><Layout><ScheduleList /></Layout></AuthGuard>} />


      {/* ✅ To-Do 관리 */}
      <Route path="/todo" element={<AuthGuard><Layout><TodoList /></Layout></AuthGuard>} />

      {/* ✅ PMS 관리 */}
      <Route path="/pms/instructions" element={<AuthGuard><Layout><InstructionList type="received" /></Layout></AuthGuard>} />
      <Route path="/pms/instructions/given" element={<AuthGuard><Layout><InstructionList type="given" /></Layout></AuthGuard>} />
      <Route path="/pms/instructions/received" element={<AuthGuard><Layout><InstructionList type="received" /></Layout></AuthGuard>} />
      <Route path="/pms/instructions/new" element={<AuthGuard><Layout><InstructionForm /></Layout></AuthGuard>} />
      <Route path="/pms/instructions/view/:id" element={<AuthGuard><Layout><InstructionView /></Layout></AuthGuard>} />
      <Route path="/pms/instructions/edit/:id" element={<AuthGuard><Layout><InstructionForm /></Layout></AuthGuard>} />
      <Route path="/pms/projects" element={<AuthGuard><Layout><ProjectList status="in_progress" /></Layout></AuthGuard>} />
      <Route path="/pms/projects/ready" element={<AuthGuard><Layout><ProjectList status="ready" /></Layout></AuthGuard>} />
      <Route path="/pms/projects/rejected" element={<AuthGuard><Layout><ProjectList status="rejected" /></Layout></AuthGuard>} />
      <Route path="/pms/projects/progress" element={<AuthGuard><Layout><ProjectList status="in_progress" /></Layout></AuthGuard>} />
      <Route path="/pms/projects/review" element={<AuthGuard><Layout><ProjectList status="review" /></Layout></AuthGuard>} />
      <Route path="/pms/projects/completed" element={<AuthGuard><Layout><ProjectList status="completed" /></Layout></AuthGuard>} />
      <Route path="/pms/projects/canceled" element={<AuthGuard><Layout><ProjectList status="canceled" /></Layout></AuthGuard>} />
      <Route path="/pms/projects/new" element={<AuthGuard><Layout><ProjectForm /></Layout></AuthGuard>} />
      <Route path="/pms/projects/edit/:id" element={<AuthGuard><Layout><ProjectForm /></Layout></AuthGuard>} />
      <Route path="/pms/projects/:id" element={<AuthGuard><Layout><ProjectView /></Layout></AuthGuard>} />
      <Route path="/pms/project-rooms" element={<AuthGuard><Layout><MyWorkspace /></Layout></AuthGuard>} />
      <Route path="/pms/project-rooms/:id" element={<AuthGuard><Layout><ProjectWorkspace /></Layout></AuthGuard>} />
      <Route path="/pms/workspace/:id" element={<AuthGuard><Layout><ProjectWorkspace /></Layout></AuthGuard>} />

      {/* ✅ 업무협조(업무지시) 전용 라우트 9종 */}
      <Route path="/work-order/matrix" element={<AuthGuard><Layout><WorkOrderMatrix /></Layout></AuthGuard>} />
      <Route path="/work-order/timeline" element={<AuthGuard><Layout><WorkOrderTimeline /></Layout></AuthGuard>} />
      <Route path="/work-order/received" element={<AuthGuard><Layout><WorkOrderListPage defaultType="received" /></Layout></AuthGuard>} />
      <Route path="/work-order/sent" element={<AuthGuard><Layout><WorkOrderListPage defaultType="sent" /></Layout></AuthGuard>} />
      <Route path="/work-order/referred" element={<AuthGuard><Layout><WorkOrderListPage defaultType="referred" /></Layout></AuthGuard>} />
      <Route path="/work-order/completed" element={<AuthGuard><Layout><WorkOrderListPage defaultType="completed" /></Layout></AuthGuard>} />
      <Route path="/work-order/temp" element={<AuthGuard><Layout><WorkOrderListPage defaultType="temp" /></Layout></AuthGuard>} />
      <Route path="/work-order/reports" element={<AuthGuard><Layout><WorkOrderListPage defaultType="reports" /></Layout></AuthGuard>} />
      <Route path="/work-order/canceled" element={<AuthGuard><Layout><WorkOrderListPage defaultType="canceled" /></Layout></AuthGuard>} />

      {/* ✅ AI */}
      <Route path="/ai/gemin" element={<AuthGuard><Layout><AiGemin /></Layout></AuthGuard>} />

      {/* ✅ 위험성평가-신규 */}
      <Route path="/risk" element={<AuthGuard><Layout><RiskList /></Layout></AuthGuard>} />
      <Route path="/risk/write" element={<AuthGuard><Layout><RiskForm /></Layout></AuthGuard>} />
      <Route path="/risk/edit/:id" element={<AuthGuard><Layout><RiskEdit /></Layout></AuthGuard>} />
      <Route path="/risk/:id" element={<AuthGuard><Layout><RiskView /></Layout></AuthGuard>} />
      <Route path="/risk-cate" element={<AuthGuard><Layout><RiskCateList /></Layout></AuthGuard>} />
      <Route path="/safety/projects" element={<AuthGuard><Layout><SafetyProjectList /></Layout></AuthGuard>} />
      <Route path="/safety/projects/:id" element={<AuthGuard><Layout><SafetyProjectDetail /></Layout></AuthGuard>} />
      <Route path="/safety/actions" element={<AuthGuard><Layout><SafetyActionList /></Layout></AuthGuard>} />
      <Route path="/safety/results" element={<AuthGuard><Layout><SafetyResultList /></Layout></AuthGuard>} />
      <Route path="/safety/master" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />
      <Route path="/safety/master/config" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />
      <Route path="/safety/master/categories" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />
      <Route path="/safety/master/processes" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />

      {/* ✅ 위험성평가 */}
      <Route path="/risk" element={<AuthGuard><Layout><RiskList /></Layout></AuthGuard>} />
      <Route path="/risk/write" element={<AuthGuard><Layout><RiskForm /></Layout></AuthGuard>} />
      <Route path="/risk/edit/:id" element={<AuthGuard><Layout><RiskEdit /></Layout></AuthGuard>} />
      <Route path="/risk/:id" element={<AuthGuard><Layout><RiskView /></Layout></AuthGuard>} />

      {/* ✅ 위험성 분류 */}
      <Route path="/risk-cate" element={<AuthGuard><Layout><RiskCateList /></Layout></AuthGuard>} />

      {/* ✅ 관리자 통합관리 */}
      <Route path="/manager/create" element={<AuthGuard><Layout><ManagerCreate /></Layout></AuthGuard>} />
      <Route path="/manager/edit/:id" element={<AuthGuard><Layout><ManagerEdit /></Layout></AuthGuard>} />
      <Route path="/manager/left-menu" element={<AuthGuard><Layout><LeftMenuList /></Layout></AuthGuard>} />
      <Route path="/manager/portlet" element={<AuthGuard><Layout><PortletList /></Layout></AuthGuard>} />
      <Route path="/manager/:id" element={<AuthGuard><Layout><ManagerDetail /></Layout></AuthGuard>} />
    </Routes>
  );
}

export default TdxMain;